export enum TabTypes {
  CLINIC = `@tab/CLINIC`,
  SCHEDULE = `@tab/SCHEDULE`,
  PROFILE = `@tab/PROFILE`,
}

export interface TabState {
  readonly selectedTab: string
}
